import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  allMonth,
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

import { FormHelperText, TextField, ThemeProvider } from "@material-ui/core";
import {
  editBookingCancel,
  editBookingVehicle,
  fetchBookingPartyAll,
  fetchBookingPartyAllFilter,
  selectBookingPartyAll,
  selectBookingPartyAllFilter,
  selectIdBooking,
  selectLoading,
} from "./bookingSlice";
import { Autocomplete } from "@material-ui/lab";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ModalEditVehicle = ({
  isOpen,
  setShow,
  row,
  setRow,
  formValues,
  setFormValues,
  id,
  getData,
  setGetData,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const classes = useStyles();
  const dataPartyAll = useSelector(selectBookingPartyAllFilter);
  const dataId = useSelector(selectIdBooking);

  useEffect(() => {
    if (getData === true) {
      dispatch(
        fetchBookingPartyAllFilter({
          booking_id: id,
          party_code: "DEALER",
          party_setting: "DEALER",
          pageNo: 1,
          pageSize: -1,
        })
      );
      setGetData(false);
    }
  }, [getData]);

  useEffect(() => {
    if (row !== null) {
      setFormValues({
        ...formValues,
        party_id: {
          value: row.party_id,
          error: false,
          required: "Y",
        },
      });
    }
  }, [row]);

  const handleClose = () => {
    setRow(null);
    setShow(false);
  };

  const handleSave = async () => {
    const params = [
      {
        booking_id: row.booking_id,
        vehicle_id: row.vehicle_id,
        bookingvehicle_id: row.bookingvehicle_id,
        party_id: formValues.party_id.value,
      },
    ];
    try {
      const response = await dispatch(editBookingVehicle(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChangeParty = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["party_id"]: {
        ...formValues["party_id"],
        value,
      },
    });
  };

  const partyOptions = dataPartyAll.map((e) => {
    return {
      value: e.party_id,
      label: e.party + "-" + e.party_name,
    };
  });

  const indexParty = partyOptions.findIndex(
    (obj) => obj.value === formValues.party_id.value
  );

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {row && (
        <>
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={isOpen}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                Update Vehicle
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ThemeProvider theme={formLabelsTheme}>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      label="VIN"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={row.vin}
                      disabled
                    />
                    <RedditTextField
                      label="VON"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={row.von}
                      disabled
                    />
                    {/* <RedditTextField
                      label="Order No"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={row.order_no}
                      disabled
                    /> */}
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      label="Vehicle Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={row.product_description}
                      disabled
                    />
                    <RedditTextField
                      label="Accessories Installed"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={row.inbound_rule === "Y" ? "Yes" : "No"}
                      disabled
                    />
                    <Autocomplete
                      disablePortal
                      name="Dealer"
                      options={partyOptions}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={
                        partyOptions.find(
                          (option) => option.value === formValues.party_id.value
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        if (newValue === null) {
                          setFormValues({
                            ...formValues,
                            ["party_id"]: {
                              ...formValues["party_id"],
                              value: "",
                            },
                          });
                        } else {
                          setFormValues({
                            ...formValues,
                            ["party_id"]: {
                              ...formValues["party_id"],
                              value: newValue.value,
                            },
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <RedditTextField
                          className={classes.margin}
                          {...params}
                          label="Dealer"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          placeholder="Select"
                          name="party_id"
                          error={formValues.party_id.error}
                          helperText={
                            formValues.party_id.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      )}
                    />
                  </Col>
                </Row>
              </ThemeProvider>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>

              {dataId.booking_status === "6010" && (
                <Button variant="primary" onClick={handleSave}>
                  Save
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
};
